import React from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../../store/AppStore'
import AdministrationAction from '../../actions/AdministrationAction'
import i18n from 'simple-react-i18n'
import MailChecker from 'mailchecker'
import HomeAction from '../../../home/actions/HomeAction'
import { connect } from 'react-redux'
import DtoUser from '../../../home/dto/DtoUser'
import UUID from 'uuid'
import ActionComponent from '../../../components/ActionComponent'
import { getDefaultMapCenter, getDefaultZoom } from '../../../utils/ApplicationUtils'
import OSM from '../../../utils/mapUtils/layers/OSM'
import ToastrAction from '../../../home/actions/ToastrAction'
import TextField from '@material-ui/core/TextField'

class AccountInformationsPanel extends ActionComponent {

	constructor(props) {
		super(props)
		this.state = {
			user: this.props.user,
			layers: [OSM()],
			mapConf: {
				size: 450,
				center: getDefaultMapCenter(this.props.user),
				zoom: getDefaultZoom(this.props.user)
			}
		}
	}

	componentWillMount() {
		AppStore.dispatch(HomeAction.setTitle(i18n.accountInformations))
	}

	componentWillReceiveProps(nextprops) {
		this.setState({
			user: nextprops.user,
			mapConf: {
				center: getDefaultMapCenter(nextprops.user),
				zoom: getDefaultZoom(nextprops.user)
			}
		})
	}

	onSubmit = () => {
		if (!MailChecker.isValid(this.state.user.email)) {
			AppStore.dispatch(ToastrAction.error(i18n.error.incorrectEmail))
		} else if (!this.state.user.mobileNumber) {
			AppStore.dispatch(ToastrAction.error(i18n.error.pleasePhoneInform))
		} else if (!this.state.user.lastName) {
			AppStore.dispatch(ToastrAction.error(i18n.error.pleaseNameInform))
		} else {
			AppStore.dispatch(AdministrationAction.updateUser(this.props.user.login, this.state.user))
		}
	}

	handleChange = (value, event) => {
		const user = Object.assign({}, this.state.user, {})
		user[value] = event.target.value.toString()
		this.setState({
			user: user
		})
	}

	getEvent = (point, zoom) => {
		const user = Object.assign({}, this.state.user, {})
		user.longitude = point[1].toString()
		user.latitude = point[0].toString()
		user.zoom = zoom.toFixed(0).toString()
		this.setState({
			user: user,
			center: [point[0], point[1]],
			zoom: zoom.toFixed(0)
		})
	}

	getloginAvatar = () => {
		return (
			<div className='row no-margin'>
				<div className='col s12 center-align'>
					<i className='material-icons responsive-img accountIcon'>account_circle</i>
				</div>
				<div className='col s12 center-align'>
					<div className='row no-margin '>
						<span>{ this.props.user.login }</span>
					</div>
				</div>
			</div>
		)
	}

	render() {
		return (
			<form>
				<div className='row card' ref={ UUID.v4() }>
					<div className='col s2'>
						{ this.getloginAvatar() }
					</div>
					<div className='col s8 '>
						<div className='row no-margin'>
							<div className='col s6'>
								<TextField
									margin='normal'
									required
									fullWidth
									id={ i18n.name }
									value={ this.state.user.lastName }
									label={ i18n.name }
									onChange={ (e) => this.handleChange('lastName', e) }
								/>
							</div>
							<div className='col s6'>
								<TextField
									margin='normal'
									fullWidth
									id={ i18n.firstname }
									value={ this.state.user.firstName }
									label={ i18n.firstname }
									onChange={ (e) => this.handleChange('firstName', e) }
								/>
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s6'>
								<TextField
									margin='normal'
									fullWidth
									id={ i18n.mobile }
									value={ this.state.user.mobileNumber }
									label={ i18n.mobile }
									onChange={ (e) => this.handleChange('mobileNumber', e) }
								/>
							</div>
							<div className='col s6'>
								<TextField
									margin='normal'
									fullWidth
									id={ i18n.phone }
									value={ this.state.user.fixNumber }
									label={ i18n.phone }
									onChange={ (e) => this.handleChange('fixNumber', e) }
								/>
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s12'>
								<TextField
									margin='normal'
									fullWidth
									required
									type={ 'email' }
									id={ i18n.mail }
									value={ this.state.user.email }
									label={ i18n.mail }
									onChange={ (e) => this.handleChange('email', e) }
								/>
							</div>
						</div>
						<div className='row no-margin'>
							<div className='col s6'>
								<TextField
									margin='normal'
									fullWidth
									id={ i18n.address }
									value={ this.state.user.address }
									label={ i18n.address }
									onChange={ (e) => this.handleChange('address', e) }
								/>
							</div>
							<div className='col s6'>
								<TextField
									margin='normal'
									fullWidth
									id={ i18n.city }
									value={ this.state.user.city }
									label={ i18n.city }
									onChange={ (e) => this.handleChange('city', e) }
								/>
							</div>
						</div>
					</div>
				</div>
			</form>
		)
	}

	componentDidMount() {
		this.setAction([
			{
				fn: () => this.onSubmit(),
				icon: 'save',
				title: i18n.save
			}
		])
	}
}

AccountInformationsPanel.propTypes = {
	user: PropTypes.instanceOf(DtoUser)
}
const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user
	}
}
export default connect(mapStateToProps)(AccountInformationsPanel)



// WEBPACK FOOTER //
// ./src/administration/components/accountInformations/AccountInformationsPanel.js